import { PolicyType } from 'store/modules/Policies/types';
import { formatCurrency } from 'utils';
import { AppliedCharge } from 'store/modules/AdvisorCharges/types';

export const arrayMove = (arr: any[], fromIndex: number, toIndex: number) => {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
};

export const filterPolicies = (
  policies: PolicyType[],
  policiesCharge: AppliedCharge[],
  activePolicy: PolicyType
) => {
  const adaptedPolcies = policies.map(policy => {
    const aplicatedCharge = policiesCharge.find(
      charge => charge.policy_id === policy.id
    );

    return {
      isChecked: !!aplicatedCharge,
      charge_allocation_amount: formatCurrency(
        aplicatedCharge ? aplicatedCharge.amount : '0'
      ),
      id: policy.id,
      display_name: policy.display_name
    };
  });

  const mainPolicyIndex = policies.findIndex(
    policy => policy.id === activePolicy.id
  );

  // PUT ACTIVE POLICIE AT TOP OF LIST
  arrayMove(adaptedPolcies, mainPolicyIndex, 0);

  return adaptedPolcies;
};
